import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { getBannerI18nSubTitleKey, getBannerI18nTitleKey } from '../utils';
import DefaultBanner from './DefaultBanner';
import { getProductNameTextFromApiName } from '../../_core/common/adapters/getProductNameText';
import UIContactSalesButton from '../../button/UIContactSalesButton';
import { useUpgradeDataFromUpgradeConfig } from './useUpgradeDataFromUpgradConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export const LimitPackBannerTitle = ({
  featureTranslationKey,
  value,
  limit
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: getBannerI18nTitleKey('upgrades.limitPackBanner.header', featureTranslationKey),
    options: {
      value,
      limit
    }
  });
};
export const LimitPackBannerSubtext = ({
  apiName,
  featureTranslationKey
}) => {
  const translatedProductName = getProductNameTextFromApiName(apiName);
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: getBannerI18nSubTitleKey('upgrades.limitPackBanner.subtext', featureTranslationKey),
    options: {
      productName: translatedProductName
    }
  });
};
const LimitPackBanner = ({
  upgradePoint,
  limit,
  value,
  displayThreshold,
  className,
  style,
  'data-test-id': dataTestId = 'limit-pack-banner',
  isUngatedUpgradeBannerRedesign2024
}) => {
  const upgradeData = useUpgradeDataFromUpgradeConfig(upgradePoint);
  const apiNameToUse = upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct];
  const getUpgradeButton = apiName => {
    if (isUngatedUpgradeBannerRedesign2024) {
      return /*#__PURE__*/_jsx(UIContactSalesButton, {
        apiName: apiName,
        upgradeData: upgradeData,
        use: "link",
        style: {
          padding: '0px'
        },
        isUpgradePoint: true
      });
    }
    return /*#__PURE__*/_jsx(UIContactSalesButton, {
      apiName: apiName,
      upgradeData: upgradeData,
      use: "tertiary-light",
      isUpgradePoint: true
    });
  };
  if (displayThreshold && value < displayThreshold) {
    return null;
  }
  return /*#__PURE__*/_jsx(DefaultBanner, {
    titleText: /*#__PURE__*/_jsx(LimitPackBannerTitle, {
      featureTranslationKey: upgradePoint.featureTranslationKey,
      value: value,
      limit: limit
    }),
    className: className,
    dataTestId: dataTestId,
    subtext: /*#__PURE__*/_jsx(LimitPackBannerSubtext, {
      apiName: apiNameToUse,
      featureTranslationKey: upgradePoint.featureTranslationKey
    }),
    style: style,
    button: getUpgradeButton(apiNameToUse),
    isUngatedUpgradeBannerRedesign2024: isUngatedUpgradeBannerRedesign2024
  });
};
export default LimitPackBanner;